import type { RouteRecordRaw, Router } from 'vue-router'

const PersonnelDisputeRoutes: RouteRecordRaw = {
  path: '/claim/personnelDispute',
  name: 'PersonnelDisputeModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'PersonnelDisputeMainRoute',
      component: () => import('./views/PersonnelDisputeView.vue'),
      meta: {
        title: 'personnelDispute.personnelDisputeClaims',
      },
    },
    {
      path: 'create',
      name: 'PersonnelDisputeCreateRoute',
      component: () => import('./views/PersonnelDisputeUpsertView.vue'),
      meta: {
        title: 'personnelDispute.createPersonnelDispute',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:personnelDisputeId',
      name: 'PersonnelDisputeEditRoute',
      component: () => import('./views/PersonnelDisputeUpsertView.vue'),
      meta: {
        title: 'personnelDispute.editPersonnelDispute',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:personnelDisputeId',
      name: 'ViewPersonnelDisputeRoute',
      component: () => import('./views/SinglePersonnelDisputeView.vue'),
      meta: {
        title: 'personnelDispute.ViewPersonnelDispute',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(PersonnelDisputeRoutes)
}
